import React from 'react'
import EvaluationPanel from '../EvaluationPanel'
import GrowthReportPanel from '../GrowthReportPanel'

export default function ReadingView({ mode, data, onClose }) {
  return (
    <div className="hwb-reading">
      <div className="hwb-reading-body">
        {mode === 'evaluation' ? (
          <EvaluationPanel
            archiveId={data?.archiveId}
            standard={data?.standard || null}
            onClose={onClose}
            chartSize={480}
          />
        ) : null}
        {mode === 'growth' ? (
          <GrowthReportPanel
            courseId={data?.courseId}
            studentId={data?.studentId}
            courseName={data?.courseName}
            onClose={onClose}
            chartSize={420}
          />
        ) : null}
      </div>
    </div>
  )
}
